'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { StoresQuadAppStore, StoresQuadAppGallery, StoresQuadGooglePlay, StoresQuadGetApps, StoresQuadRuStore, StoresQuadGalaxy, StoresQuadDownloadRu, StoresQuadDownloadEn, StoresQuadHowInstallRu, StoresQuadHowInstallEn, StoresHorizontalAppStoreEn, StoresHorizontalHuaweiEn, StoresHorizontalGoogleEn, StoresHorizontalGetAppsEn, StoresHorizontalRuStoreEn, StoresHorizontalGalaxyStoreEn, StoresHorizontalAPKEn, StoresHorizontalHowInstallEn, StoresHorizontalAppStoreRu, StoresHorizontalHuaweiRu, StoresHorizontalGoogleRu, StoresHorizontalGetAppsRu, StoresHorizontalRuStoreRu, StoresHorizontalGalaxyStoreRu, StoresHorizontalAPKRu, StoresHorizontalHowInstallRu } from '@s7/icons';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var variantsCompact = {
    appstore: function() {
        return StoresQuadAppStore;
    },
    appgallery: function() {
        return StoresQuadAppGallery;
    },
    googleplay: function() {
        return StoresQuadGooglePlay;
    },
    getapps: function() {
        return StoresQuadGetApps;
    },
    rustore: function() {
        return StoresQuadRuStore;
    },
    galaxystore: function() {
        return StoresQuadGalaxy;
    },
    download: function(locale) {
        return locale === "ru" ? StoresQuadDownloadRu : StoresQuadDownloadEn;
    },
    howtoinstall: function(locale) {
        return locale === "ru" ? StoresQuadHowInstallRu : StoresQuadHowInstallEn;
    }
};
var variantsEn = {
    appstore: StoresHorizontalAppStoreEn,
    appgallery: StoresHorizontalHuaweiEn,
    googleplay: StoresHorizontalGoogleEn,
    getapps: StoresHorizontalGetAppsEn,
    rustore: StoresHorizontalRuStoreEn,
    galaxystore: StoresHorizontalGalaxyStoreEn,
    download: StoresHorizontalAPKEn,
    howtoinstall: StoresHorizontalHowInstallEn
};
var variantsRu = {
    appstore: StoresHorizontalAppStoreRu,
    appgallery: StoresHorizontalHuaweiRu,
    googleplay: StoresHorizontalGoogleRu,
    getapps: StoresHorizontalGetAppsRu,
    rustore: StoresHorizontalRuStoreRu,
    galaxystore: StoresHorizontalGalaxyStoreRu,
    download: StoresHorizontalAPKRu,
    howtoinstall: StoresHorizontalHowInstallRu
};
var AppItemIcon = function(props) {
    var _variantsCompact_variant;
    var variant = props.variant, compact = props.compact, locale = props.locale, others = _object_without_properties_loose(props, [
        "variant",
        "compact",
        "locale"
    ]);
    var Icon = compact ? (_variantsCompact_variant = variantsCompact[variant]) == null ? void 0 : _variantsCompact_variant.call(variantsCompact, locale) : locale === "ru" ? variantsRu[variant] : variantsEn[variant];
    return Icon ? /*#__PURE__*/ jsx(Icon, _extends({}, others)) : null;
};

export { AppItemIcon };
